
import { Box, Button, Drawer } from '@mui/material';
import orkestamediaLogo from '../../assets/images/orkestamedia-logo.png'
import orkestamediaWhiteLogo from '../../assets/images/orkestamedia-logo-white.png'
import useStyles from './styles';
import React, { useEffect, useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';

const Header = () => {
  const classes = useStyles();

  const [isScrolled, setIsScrolled] = useState(false);
  const [drawerToggle, setDrawerToggle] = React.useState(false);

  const toggleDrawer =
    (open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
          event.type === 'keydown' &&
          ((event as React.KeyboardEvent).key === 'Tab' ||
            (event as React.KeyboardEvent).key === 'Shift')
        ) {
          return;
        }
        setDrawerToggle(open);
      };


  useEffect(() => {
    const handleScroll = () => {
      // Cambia `70` por la altura de tu header si es diferente.
      setIsScrolled(window.scrollY > 70);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header
      className={`${classes.header} ${isScrolled ? classes.scrolledHeader : ""}`}
    >
      <div className={classes.images}>
        <a href="/">
          <img className={classes.imgLogos} src={isScrolled ? orkestamediaLogo : orkestamediaWhiteLogo} alt='Orkestamedia Logo' />
        </a>
      </div>
      <div className={classes.buttonsDiv}>
        <Button sx={{ color: isScrolled ? '#1356DA' : '#ffffff', fontWeight: 'bold', textTransform: 'capitalize', fontSize: '20px' }} className={classes.buttons} variant='text' href='#plataforma'>Plataforma</Button>
        <Button sx={{ color: isScrolled ? '#1356DA' : '#ffffff', fontWeight: 'bold', textTransform: 'capitalize', fontSize: '20px' }} className={classes.buttons} variant='text' href='#acerca-de'>Acerca de</Button>
        <Button sx={{ color: isScrolled ? '#1356DA' : '#ffffff', fontWeight: 'bold', textTransform: 'capitalize', fontSize: '20px' }} className={classes.buttons} variant='text' href='#contacto'>Contacto</Button>
      </div>
      <Box className={classes.burger}>
        <Button onClick={toggleDrawer(true)}>
          <MenuIcon sx={{ color: isScrolled ? '#1356DA' : '#ffffff' }} />
        </Button>
        <Drawer
          anchor='right'
          open={drawerToggle}
          onClose={toggleDrawer(false)}
        >
          <Box
            sx={{ width: 250, textAlign: 'center', paddingTop: '15px'}}
            role="presentation"
            onClick={toggleDrawer(false)}
            onKeyDown={toggleDrawer(false)}
            className={classes.burger}
          >
              <Button sx={{ display: 'block', width: '100%', color: '#1356DA', fontWeight: 'bold', textTransform: 'capitalize', fontSize: '20px' }} className={classes.buttons} variant='text' href='#plataforma'>Plataforma</Button>
              <Button sx={{ display: 'block', width: '100%', color: '#1356DA', fontWeight: 'bold', textTransform: 'capitalize', fontSize: '20px' }} className={classes.buttons} variant='text' href='#acerca-de'>Acerca de</Button>
              <Button sx={{ display: 'block', width: '100%', color: '#1356DA', fontWeight: 'bold', textTransform: 'capitalize', fontSize: '20px' }} className={classes.buttons} variant='text' href='#contacto'>Contacto</Button>
            
          </Box>
        </Drawer>
      </Box>
    </header>
  );
};

export default Header;